import _ from 'lodash';
import {
  Fragment,
  useMemo
} from 'react';

import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { TimeFrame } from 'generated/graphql';

import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

import * as ds from './dataService';



export type StockPriceLineChartProps = {
  listedCompanyId: string;
  timeFilter: TimeFrame;
};

export const FC = (props: StockPriceLineChartProps) => {
  const { data } = ds.useQuery(props.listedCompanyId, props.timeFilter);
  const maxInterval = useMemo(() => __getMaxInterval(data), [data]);
  const theme = useTheme();



  return (
    <Box
      paddingTop='1rem'
      marginLeft='-1.5rem'
      flex='1 1 0'
    >
      <ResponsiveContainer
        height={200}
        minWidth={0}
        aspect={undefined}
      >
        <AreaChart
          height={500}
          data={data.points}
        >
          <defs>
            <linearGradient id='rate' x1='0' y1='-.5' x2='1' y2='1'>
              <stop offset='0' stopColor='#02C37E' stopOpacity={0.8} />
              <stop offset='95%' stopColor='#82ca9d' stopOpacity={0} />
            </linearGradient>
          </defs>


          <Tooltip<number, string> content={(e) => (
            <Stack direction='column'>
              {e.payload?.map(({ payload }, i) => (
                <Fragment key={i}>
                  <Typography variant='toolTip'>{payload.y}</Typography>
                  <Typography variant='toolTip'>{payload.fullDate.toFormat('MM-dd-yyyy')}</Typography>
                </Fragment>
              ))}
            </Stack>
          )}
          />

          <XAxis
            fontFamily='Lexend'
            interval='preserveStartEnd'
            dataKey='x'
            ticks={data.domainTicks}
          />

          <YAxis
            type='number'
            domain={[
              0,
              maxInterval ?? 0
            ]}
            interval='preserveStartEnd'
            axisLine
            tick
          />

          <Area
            type='monotone'
            dataKey='y'
            stroke={theme.palette.primary.main}
            fillOpacity={1}
            fill='url(#rate)'
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};



function __getMaxInterval(data: ds.IData) {
  return _.maxBy(data.points, (p) => p.y)?.y;
}

